import styled, { keyframes } from 'styled-components';

const bounce = keyframes`
  0%,80%,100% { transform: scale(0); }
  40% { transform: scale(1); }
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: .5rem;
`;

export const Dot = styled.div`
  width: .75rem;
  height: .75rem;
  border-radius: 50%;
  background: ${props => props.color};
  animation: ${bounce} 1.4s infinite;
  animation-delay: ${props => props.delay};
`;
